import { MenuItem } from "@/types/menuTypes";

export const MENU_ITEMS: MenuItem[] = [
  { 
    displayName: "Accueil", 
    link: "/", 
    public: true 
  },
 /* {
    displayName: "Chiffres et analyses", 
    link: "/chiffres-analyses", 
    public: true 
  },*/
  { 
    displayName: "Services", 
    link: "/services", 
    public: true 
  },
  { 
    displayName: "Actualités", 
    link: "/actu", 
    public: true 
  },
  { 
    displayName: "Centre d'aide et FAQ", 
    link: "/faq", 
    public: true 
  },
  { 
    displayName: "Dashboard", 
    link: process.env.NEXT_PUBLIC_DASHBOARD_LINK || '/dashboard', 
    public: false 
  }
];